export default {
  data() {
    return {
      tableAlign: 'center', // 表格对齐方式
      formLabelWidth: "140px", // 表单label宽度
      formItemPadding: "10px", // 表单项，左右边距
      inputWidth1: "160px", // 输入框，时间选择，下拉框宽度,
      dpValueFormat: "yyyy-MM-dd HH:mm:ss", // 时间选择控制输出日期格式
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },

  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
